const masteringFR = {
    "view": {
        "table": {
            "title": "Votre liste de mastering",
            "column": {
                "created_by": "Créé par",
                "total_songs": "Nombre de chansons",
                "mastered_songs": "Total des chansons masterisées",
                "created": "Date de création",
                "action": "Action"
            },
            "button": {
                "open": "OUVRIR",
                "edit": "ÉDITER",
                "export_csv": "Exporter CSV"
            },
            "placeholder": {
                "search": "Rechercher..."
            }
        },
        "message": {
            "noAccess": "Vous n'avez pas accès à ce module, veuillez contacter l'équipe de support pour plus d'informations.",
            "subscriptionExpired": "Votre abonnement a expiré. Veuillez <1>reprendre</1> votre abonnement pour profiter de cette fonctionnalité.",
            "subscriptionUpgrade": "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité. Veuillez <1>mettre à niveau</1> votre plan d'abonnement pour profiter de cette fonctionnalité.",
            "noCredits": "Vous n'avez plus de crédits de mastering audio. Découvrez-en plus sur les crédits <1>ici</1> et veuillez contacter notre équipe de support.",
            "learnMore": "Découvrez tout sur le mastering audio <1>ici</1>. Pour plus d'informations et <3>crédits</3>, veuillez contacter notre équipe de support."
        }
    },
    "add": {
        "form": {
            "step1": {
                "title": "Combien de chansons souhaitez-vous masteriser ?",
                "label": {
                    "number_of_songs": "Nombre de chansons"
                },
                "option": {
                    "songsCount": {
                        "selectNoOfSongs": "Sélectionnez le nombre de chansons",
                        "song": "Chanson",
                        "songs": "Chansons"
                    }
                },
                "button": {
                    "continue": "Continuer"
                }
            },
            "step2": {
                "title": "Sélectionnez vos chansons pour le mastering",
                "button": {
                    "save": "Enregistrer"
                }
            }
        },
        "message": {
            "uploadSuccess": "Chansons de mastering audio téléchargées avec succès !",
            "creationSuccess": "Le mastering audio a été créé ! Veuillez maintenant sélectionner vos chansons dans la section ci-dessous.",
            "error": "Une erreur s'est produite. Veuillez réessayer."
        },
        "modal": {
            "addMastering": {
                "header": "Êtes-vous sûr de vouloir ajouter un nouveau mastering ?",
                "body": "Remarque : Cela entraînera une déduction de {{credits}} crédits."
            },
            "saveMastering": {
                "header": "Êtes-vous sûr de vouloir enregistrer le mastering audio ?",
                "body": "Remarque : Veuillez vous assurer de télécharger les fichiers audio corrects car ils ne peuvent pas être modifiés une fois enregistrés."
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "selectSongs": "Sélectionnez vos chansons pour le mastering"
            },
            "button": {
                "save": "Enregistrer"
            }
        },
        "message": {
            "success": "Mastering audio mis à jour avec succès !",
            "errorCantUpdate": "Le mastering audio ne peut pas être mis à jour une fois les chansons téléchargées !",
            "errorMasteringDoesNotExist": "Le mastering ne peut pas être mis à jour car il n'existe pas !",
            "error": "Une erreur s'est produite. Veuillez réessayer."
        },
        "modal": {
            "saveMastering": {
                "header": "Êtes-vous sûr de vouloir enregistrer le mastering audio ?",
                "body": "Remarque : Veuillez vous assurer de télécharger les fichiers audio corrects car ils ne peuvent pas être modifiés une fois enregistrés."
            }
        }
    },
    "viewSongs": {
        "title": "Chansons de mastering audio",
        "table": {
            "column": {
                "name": "Nom",
                "preset": "Préréglage",
                "intensityAndLoudness": "Intensité & Sonie",
                "preview": "Aperçu",
                "master": "Master",
                "previewResult": "Résultat de l'aperçu",
                "masteringResult": "Résultat du mastering",
                "mastered": "Masterisé",
                "action": "Action"
            },
            "label": {
                "previewAttemptsLeft": "{{count}} Restant",
                "notAvailable": "Non disponible"
            },
            "button": {
                "generate": "Générer",
                "edit": "Éditer",
                "exportCsv": "Exporter CSV"
            },
            "option": {
                "preset": {
                    "acoustic": "Acoustique",
                    "allGenres": "Tous genres",
                    "classical": "Classique",
                    "clubHouseTechno": "Club - House - Techno",
                    "edmMusic": "Musique EDM",
                    "electronic": "Électronique",
                    "electronicRaw": "Électronique Brut",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Musique Pop",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Centré sur la voix"
                }
            },
            "message": {
                "previewDownloadTooltip": "L'aperçu est en cours de génération. Veuillez patienter 5-6 minutes pour qu'il apparaisse.",
                "masteringDownloadTooltip": "Le mastering est en cours. Veuillez patienter 7-15 minutes pour qu'il apparaisse.",
                "alreadyMasteredTooltip": "Cette chanson est déjà masterisée."
            }
        },
        "message": {
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
            "successMaster": "Chanson envoyée pour la génération de mastering !<br/>Remarque : Veuillez vérifier dans quelques minutes car cela prend 7-15 minutes pour générer le mastering.",
            "successPreview": "Chanson envoyée pour la génération de l'aperçu du mastering !<br/>Remarque : Veuillez vérifier dans quelques minutes car cela prend 5-6 minutes pour générer l'aperçu du mastering."
        },
        "modal": {
            "generateMastering": {
                "header": "Générer le mastering",
                "body": "Êtes-vous sûr de vouloir générer le mastering ?  C'est une action irréversible ! Le résultat du mastering apparaîtra dans 7-15 minutes.",
                "message": {
                    "success": "Chanson envoyée pour la génération de mastering !"
                }
            },
            "generateMasteringPreview": {
                "header": "Générer l'aperçu du mastering",
                "body": "Êtes-vous sûr de vouloir générer l'aperçu du mastering ? Le résultat de l'aperçu apparaîtra dans 5-6 minutes",
                "message": {
                    "success": "Chanson envoyée pour la génération de l'aperçu du mastering !"
                }
            }
        }
    },
    "songParametersUpdate": {
        "title": "Modifier les paramètres de la chanson",
        "form": {
            "label": {
                "intensity": "Intensité",
                "loudness": "Sonie",
                "preset": "Préréglage"
            },
            "placeholder": {
                "preset": "Sélectionner un préréglage"
            },
            "option": {
                "preset": {
                    "acoustic": "Acoustique",
                    "allGenres": "Tous genres",
                    "classical": "Classique",
                    "clubHouseTechno": "Club - House - Techno",
                    "edmMusic": "Musique EDM",
                    "electronic": "Électronique",
                    "electronicRaw": "Électronique Brut",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Musique Pop",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Centré sur la voix"
                }
            },
            "button": {
                "submit": "Soumettre"
            },
            "message": {
                "intensityTooltip": "La quantité de dynamique, d'EQ et de traitement appliquée à votre chanson par rapport à l'ensemble de la piste et au préréglage sélectionné. L'utilisation maximale se produira à 100 %. Nous vous recommandons d'expérimenter ce réglage pour trouver le point idéal qui vous convient le mieux.",
                "loudnessTooltip": "Le niveau cible de sonie intégrée. Mesuré en unités de sonie relatives à l'échelle complète (LUFS). Nous vous recommandons d'expérimenter ce réglage pour trouver le point idéal qui vous convient le mieux. Selon le style et le genre de votre chanson, les meilleurs résultats devraient apparaître entre -15 et -9 db"
            }
        },
        "message": {
            "success": "Les paramètres de la chanson ont été mis à jour !",
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !",
            "songMastered": "Les paramètres de la chanson ne peuvent pas être mis à jour une fois la chanson masterisée !"
        }
    },
    "songRow": {
        "label": {
            "songs": "Chansons",
            "name": "Nom",
            "genre": "Genre",
            "preset": "Préréglage",
            "intensity": "Intensité",
            "loudness": "Sonie",
            "audioFile": "Fichier audio"
        },
        "placeholder": {
            "name": "c'est-à-dire Nom de la chanson",
            "genre": "c'est-à-dire Pop",
            "preset": "Sélectionner un préréglage"
        },
        "option": {
            "preset": {
                "acoustic": "Acoustique",
                "allGenres": "Tous genres",
                "classical": "Classique",
                "clubHouseTechno": "Club - House - Techno",
                "edmMusic": "Musique EDM",
                "electronic": "Électronique",
                "electronicRaw": "Électronique Brut",
                "hipHop": "Hip Hop",
                "hipHopBass": "Hip Hop Bass",
                "popMusic": "Musique Pop",
                "popRnB": "Pop & RnB",
                "rockMetal": "Rock & Metal",
                "trap": "Trap",
                "vocalFocused": "Centré sur la voix"
            }
        },
        "message": {
            "intensityTooltip": "La quantité de dynamique, d'EQ et de traitement appliquée à votre chanson par rapport à l'ensemble de la piste et au préréglage sélectionné. L'utilisation maximale se produira à 100 %. Nous vous recommandons d'expérimenter ce réglage pour trouver le point idéal qui vous convient le mieux.",
            "loudnessTooltip": "Le niveau cible de sonie intégrée. Mesuré en unités de sonie relatives à l'échelle complète (LUFS). Nous vous recommandons d'expérimenter ce réglage pour trouver le point idéal qui vous convient le mieux. Selon le style et le genre de votre chanson, les meilleurs résultats devraient apparaître entre -15 et -9 db",
            "audioFileTooltip": "Les formats audio pris en charge sont : AAC, AIFF, FLAC, MP3, OPUS, VORBIS et WAV. Nous recommandons fortement d'utiliser des types de fichiers sans perte tels que AIFF, FLAC ou WAV. Notre outil de mastering renverra toujours le même type de fichier que le fichier original. Gardez à l'esprit que vous avez besoin d'un fichier WAV de 16 bits, 44,1 khz pour la distribution.",
            "errorSongNameRequired": "Veuillez entrer le nom de la chanson",
            "errorSongNameLength": "Le nom de la chanson ne doit pas dépasser 80 caractères.",
            "errorGenreRequired": "Veuillez entrer le genre de la chanson",
            "errorGenreLength": "Le genre de la chanson ne doit pas dépasser 50 caractères.",
            "errorPresetRequired": "Un préréglage doit être sélectionné.",
            "errorAudioFileRequired": "Veuillez sélectionner le fichier de la chanson",
            "errorAudioFileValid": "Veuillez télécharger un fichier audio valide"
        }
    },
    "masteringConfirmModal": {
        "header": "Êtes-vous sûr de vouloir enregistrer le mastering audio ?",
        "body": "Remarque : Veuillez vous assurer de télécharger les fichiers audio corrects car ils ne peuvent pas être modifiés une fois enregistrés.",
        "button": {
            "cancel": "Annuler",
            "confirm": "Confirmer"
        },
        "message": {
            "error": "Quelque chose s'est mal passé ! Veuillez rafraîchir la page et réessayer !"
        }
    }
};

export default masteringFR;